import { useEntity } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { apiDocsConfigRef } from '@backstage/plugin-api-docs';
import { ApiEntity } from '@backstage/catalog-model';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import { EmptyState } from '../../../../shared/components/empty-state';

export const ApiDefinitionCard = () => {
  const { entity } = useEntity<ApiEntity>();
  const apiDocsConfig = useApi(apiDocsConfigRef);
  const { t } = useTranslationRef(appTranslationRef);

  const definition = entity.spec?.definition as string | undefined;
  const widget = apiDocsConfig.getApiDefinitionWidget(entity);

  return widget && definition ? (
    widget.component(definition)
  ) : (
    <EmptyState title={t('apiDefinition.unsupported')} />
  );
};
